import React, { useEffect } from 'react';
import { Center, Spinner, Text, VStack } from '@chakra-ui/react';
import { useOktaAuth } from '@okta/okta-react';


export const LoginPage: React.FC = () => {
  const { authState, oktaAuth } = useOktaAuth();


  useEffect(() => {
    if (!authState) return;

    if (authState.isAuthenticated) {
      // Don't navigate here - let restoreOriginalUri handle it
      return;
    } else if (!authState.isPending) {
      oktaAuth.signInWithRedirect();
    }
  }, [authState, oktaAuth]);

  return (
    <Center h="100vh">
      <VStack spacing={4}>
        <Spinner size="xl" />
        <Text>Redirecting to login...</Text>
      </VStack>
    </Center>
  );
};